import { render, staticRenderFns } from "./ChannelMenuButton.vue?vue&type=template&id=38ea6471&scoped=true&"
import script from "./ChannelMenuButton.vue?vue&type=script&lang=ts&"
export * from "./ChannelMenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelMenuButton.vue?vue&type=style&index=0&id=38ea6471&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea6471",
  null
  
)

export default component.exports